import { ObservableMap } from 'mobx';
import { IContextualMenuProps, IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';
import { ComposeViewState } from 'owa-mail-compose-store';
import { protectionStore } from 'owa-mail-protection/lib/store/protectionStore';
import protectMessageAndRemoveAddin from 'owa-mail-compose-actions/lib/utils/protectMessageAndRemoveAddin';
import shouldDisableEncryptionButton from 'owa-mail-protection/lib/utils/rms/shouldDisableEncryptionButton';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import setIRMData from 'owa-mail-protection/lib/actions/rms/setIRMData';
import getEncryptionInfoBarMessageId from 'owa-mail-protection/lib/utils/rms/getEncryptionInfoBarMessageId';
import getMessageClassificationContextMenuItemProps from 'owa-mail-protection/lib/utils/classification/getMessageClassificationContextMenuItemProps';
import clearClassification from 'owa-mail-protection/lib/utils/classification/clearClassification';

export function getEncryptionDropDownSubMenu(
    viewState: ComposeViewState,
    templateIds: string[]
): IContextualMenuProps {
    const { protectionViewState } = viewState;
    const { clpViewState, IRMData } = protectionViewState;
    const { rmsTemplates } = protectionStore;

    return {
        items: templateIds
            .map(templateId => {
                const itemTemplate = rmsTemplates.get(templateId);
                if (itemTemplate) {
                    const menuItem = getBaseTemplateContextMenuItemProps(
                        itemTemplate,
                        IRMData,
                        viewState,
                        rmsTemplates
                    );
                    menuItem.disabled =
                        shouldDisableEncryptionButton(protectionViewState) ||
                        clpViewState.selectedCLPLabel?.isEncryptingLabel;
                    return menuItem;
                }
                return null;
            })
            .filter(item => item != null),
    };
}

export function getIRMTemplatesDropDown(viewState: ComposeViewState): IContextualMenuProps {
    const { protectionViewState } = viewState;
    const { classificationViewState, IRMData } = protectionViewState;
    const { rmsTemplates, messageClassifications } = protectionStore;
    const subMenuItems = [];

    messageClassifications.forEach(classification => {
        const menuItem = getMessageClassificationContextMenuItemProps(
            classification,
            classificationViewState,
            viewState,
            () => {
                clearIrmData(viewState);
            }
        );
        subMenuItems.push(menuItem);
    });

    rmsTemplates.forEach(template => {
        const menuItem = getBaseTemplateContextMenuItemProps(
            template,
            IRMData,
            viewState,
            rmsTemplates
        );
        menuItem.disabled = shouldDisableEncryptionButton(protectionViewState);
        subMenuItems.push(menuItem);
    });

    return {
        items: subMenuItems,
    };
}

function getBaseTemplateContextMenuItemProps(
    template: RightsManagementLicenseDataType,
    IRMData: RightsManagementLicenseDataType,
    viewState: ComposeViewState,
    rmsTemplates: ObservableMap<string, RightsManagementLicenseDataType>
): IContextualMenuItem {
    const { RmsTemplateId, TemplateName } = template;
    const { protectionViewState } = viewState;
    const { classificationViewState } = protectionViewState;

    return {
        name: TemplateName,
        key: RmsTemplateId,
        onClick: () => {
            clearClassification(classificationViewState, viewState);
            if (IRMData && IRMData.RmsTemplateId === RmsTemplateId) {
                removeInfoBarMessage(viewState, getEncryptionInfoBarMessageId(RmsTemplateId));
                setIRMData(protectionViewState, null);
            } else {
                protectMessageAndRemoveAddin(viewState, RmsTemplateId);
            }
        },
        canCheck: true,
        checked: IRMData && IRMData.RmsTemplateId == RmsTemplateId,
    };
}

export function clearIrmData(viewState: ComposeViewState) {
    const { IRMData } = viewState.protectionViewState;
    if (IRMData) {
        removeInfoBarMessage(viewState, getEncryptionInfoBarMessageId(IRMData.RmsTemplateId));
        setIRMData(viewState.protectionViewState, null /*IRMData*/);
    }
}
